/* Region list is stored in CRS, for given brand under "Regions" SingleRowText group */
export const REGIONS_CRS_GROUP_KEY = "regions";
